import { BsGridFill } from "react-icons/bs";
import { IoIosPaper, IoMdPerson, IoMdPeople } from "react-icons/io";
import { IoStorefront, IoWallet } from "react-icons/io5";
import {
  FaUsersCog,
  FaSignOutAlt,
  FaBell,
  FaUserCircle,
  FaUsers,
  FaMoneyBill,
  FaCreditCard,
  FaBuilding,
  FaDelicious,
} from "react-icons/fa";
import { HiTag } from "react-icons/hi";
import { BsFillGearFill } from "react-icons/bs";

import AppRoutePath from "../../../router/AppRoutePath";
import { AuthorizationList } from "../authorization/Authorization";

export const SIDEBAR_MENU = {
  mainMenu: {
    text: "Menu Utama",
    menus: [
      {
        name: "Dashboard",
        path: AppRoutePath.DASHBOARD,
        icon: <BsGridFill />,
        subMenus: [],
        key: AuthorizationList.no_role,
      },
      {
        name: "Tugas Harian",
        key: AuthorizationList.view_task,
        path: AppRoutePath.TASK_DAILY_TASK,
        icon: <BsGridFill />,
        subMenus: [],
      },
    ],
  },
  employeeMenu: {
    text: "Pegawai",
    menus: [
      {
        name: "User",
        key: AuthorizationList.view_user,
        path: AppRoutePath.USERS_LIST_USER,
        icon: <IoMdPerson />,
        subMenus: [],
      },
      {
        name: "Semua Pegawai",
        key: AuthorizationList.view_employee,
        path: AppRoutePath.USERS_EMPLOYEE,
        icon: <IoMdPeople />,
        subMenus: [],
      },
      {
        name: "Jabatan",
        key: AuthorizationList.view_jabatan,
        path: AppRoutePath.USERS_JABATAN,
        icon: <IoMdPerson />,
        subMenus: [],
      },
    ],
  },
  jemputMenu: {
    text: "Jemput Gadai",
    menus: [
      {
        bubble: "pick_up_gadai",
        name: "Permohonan Jemput Gadai",
        key: AuthorizationList.view_pick_up_gadai,
        path: AppRoutePath.PERMOHONAN_JEMPUT_GADAI,
        icon: <FaDelicious />,
        subMenus: [],
      },
      {
        bubble: "scheduled_pick_up_gadai",
        name: "Jemput Gadai Terjadwal",
        key: AuthorizationList.view_sheduled_pick_up_gadai,
        path: AppRoutePath.JEMPUT_GADAI_TERJADWAL,
        icon: <FaBuilding />,
        subMenus: [],
      },
    ],
  },
  pengembalianMenu: {
    text: "Pengembalian Barang",
    menus: [
      {
        bubble: "delivery_gadai",
        name: "Permohonan Pengembalian Barang",
        key: AuthorizationList.view_delivery_gadai,
        path: AppRoutePath.PERMOHONAN_PENGEMBALIAN_BARANG,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        bubble: "scheduled_delivery_gadai",
        name: "Pengembalian Terjadwal",
        key: AuthorizationList.view_scheduled_delivery_gadai,
        path: AppRoutePath.PENGEMBALIAN_TERJADWAL,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        name: "Riwayat Pengembalian",
        key: AuthorizationList.view_history_delivery_gadai,
        path: AppRoutePath.HISTORY_TERJADWAL,
        icon: <FaBuilding />,
        subMenus: [],
      },
    ],
  },
  gadaiExclusive: {
    text: "Gadai Khusus",
    menus: [
      {
        name: "Gadai Barang Eksklusif",
        key: AuthorizationList.view_gadai_exclusive,
        path: AppRoutePath.EXCLUSIVE_LIST,
        icon: <FaDelicious />,
        subMenus: [],
      },
    ],
  },
  gadaiMenu: {
    text: "Transaksi Gadai",
    menus: [
      {
        bubble: "menu_cashless_loan",
        name: "Pinjaman Non Tunai",
        key: AuthorizationList.view_waiting_disburse,
        path: AppRoutePath.LOAN_NONCASH,
        icon: <BsGridFill />,
        subMenus: [],
      },
      {
        bubble: "menu_cashless_payment",
        name: "Pembayaran Non Tunai",
        key: AuthorizationList.view_manual_transfer,
        path: AppRoutePath.PAYMENT_NONCASH,
        icon: <FaCreditCard />,
        subMenus: [],
      },
      {
        name: "Tebus Gadai",
        key: AuthorizationList.view_manual_transfer,
        path: AppRoutePath.REDEEM,
        icon: <FaCreditCard />,
        subMenus: [],
      },
      {
        name: "Daftar Nasabah",
        key: AuthorizationList.view_customer,
        path: AppRoutePath.CUSTOMER,
        icon: <IoMdPeople />,
        subMenus: [],
      },
    ],
  },
  financeMenu: {
    text: "Keuangan",
    menus: [
      {
        name: "Payment Approval",
        key: AuthorizationList.update_midtrans,
        path: AppRoutePath.MIDTRANS_APPROVAL,
        icon: <FaUsers />,
        subMenus: [],
      },
      {
        name: "Pencairan Komisi",
        key: AuthorizationList.view_customer_commission,
        path: AppRoutePath.COMMISSION_DISBURSEMENT,
        icon: <FaUsers />,
        subMenus: [],
      },
      {
        bubble: "top_up_and_deposit",
        name: "Top Up & Setor",
        key: AuthorizationList.view_top_up_deposit,
        path: AppRoutePath.TOPUP_DEPOSIT,
        icon: <FaMoneyBill />,
        subMenus: [],
      },
      {
        name: "Voucher",
        // key: AuthorizationList.view_top_up_deposit,
        path: AppRoutePath.VOUCHER,
        icon: <FaMoneyBill />,
        subMenus: [],
      },
      {
        name: "Pengembalian Dana",
        key:
          AuthorizationList.view_report_refund || AuthorizationList.view_refund,
        path: "#",
        icon: <IoIosPaper />,
        subMenus: [
          {
            name: "Daftar Pengembalian Dana",
            key: AuthorizationList.view_report_refund,
            path: AppRoutePath.REFUND_REPORT,
          },
          {
            name: "Permintaan Pengembalian Dana",
            key: AuthorizationList.view_refund,
            path: AppRoutePath.REFUND_REQUEST,
          },
          {
            name: "Pengembalian Dana Kadaluwarsa",
            key: AuthorizationList.view_refund,
            path: AppRoutePath.REFUND_EXPIRED,
          },
        ],
      },
      {
        name: "Laporan",
        key:
          AuthorizationList.view_report_gadai ||
          AuthorizationList.view_report_failed_gadai,
        path: "#",
        icon: <IoIosPaper />,
        subMenus: [
          {
            name: "Daftar Gadai",
            key: AuthorizationList.view_report_gadai,
            path: AppRoutePath.PAWN_TRANSACTION_REPORT,
          },
          {
            name: "Transaksi Gadai",
            key: AuthorizationList.view_transaction_gadai,
            path: AppRoutePath.PAWN_TRANSACTION,
          },
          {
            name: "Transaksi Modal & Kas",
            key: AuthorizationList.view_transaction_outlet_cash,
            path: AppRoutePath.CAPITAL_CASH_TRANSACTION,
          },
          {
            bubble: "failed_redeem",
            name: "Gagal Tebus",
            key: AuthorizationList.view_report_failed_gadai,
            path: AppRoutePath.FAILED_REDEEM_REPORT,
          },
        ],
      },
    ],
  },
  settingMenu: {
    text: "Pengaturan",
    menus: [
      {
        name: "Modal & Kas Outlet",
        key: AuthorizationList.view_outlet_cash,
        path: AppRoutePath.CAPITAL_CASH_OUTLET,
        icon: <IoWallet />,
        subMenus: [],
      },
      {
        name: "Kartu Debit Outlet",
        key: AuthorizationList.view_debit_card,
        path: AppRoutePath.OUTLET_DEBIT_CARD,
        icon: <IoWallet />,
        subMenus: [],
      },
      {
        name: "Pengaturan Membership",
        key: AuthorizationList.view_customer_membership_settings,
        path: AppRoutePath.MEMBERSHIP_SETTING,
        icon: <IoWallet />,
        subMenus: [],
      },
      {
        name: "Bank Account",
        key: AuthorizationList.view_bank,
        path: AppRoutePath.BANK_LIST,
        icon: <IoWallet />,
        subMenus: [],
      },
      {
        name: "Cabang/Outlet",
        key: AuthorizationList.view_outlet,
        path: AppRoutePath.USERS_OUTLET,
        icon: <IoStorefront />,
        subMenus: [],
      },
      {
        name: "Storage",
        key: AuthorizationList.view_storage,
        path: AppRoutePath.STORAGE,
        icon: <IoStorefront />,
        subMenus: [],
      },
      {
        name: "Shelf",
        key: AuthorizationList.view_shelf,
        path: AppRoutePath.SHELF,
        icon: <IoStorefront />,
        subMenus: [],
      },
      {
        name: "Role",
        key: AuthorizationList.view_role,
        path: AppRoutePath.ROLE,
        icon: <FaUsersCog />,
        subMenus: [],
      },

      {
        name: "Reguler Offer",
        key: AuthorizationList.view_regular_offer,
        path: AppRoutePath.CAMPAIGN_DEFAULT,
        icon: <HiTag />,
        subMenus: [],
      },
      {
        name: "Promo Offer",
        key: AuthorizationList.view_promo_offer,
        path: AppRoutePath.CAMPAIGN,
        icon: <HiTag />,
        subMenus: [],
      },
      {
        name: "Kategori Produk",
        key: AuthorizationList.view_product,
        path: AppRoutePath.PRODUCT_CATEGORY,
        icon: <HiTag />,
        subMenus: [],
      },
      {
        name: "Label",
        key: AuthorizationList.view_label,
        path: AppRoutePath.LABEL,
        icon: <HiTag />,
        subMenus: [],
      },
      {
        name: "Area Jemput Gadai",
        key: AuthorizationList.view_area,
        path: AppRoutePath.AREA_LIST,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        name: "Juru Taksir",
        key: AuthorizationList.view_appraiser,
        path: AppRoutePath.APPRAISER_LIST,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        name: "Juru Taksir per Outlet",
        key: AuthorizationList.view_outlet_appraiser,
        path: AppRoutePath.APPRAISER_LIST_BY_OUTLET,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        name: "Notifikasi Jatuh Tempo",
        key: AuthorizationList.view_notification_group,
        path: AppRoutePath.NOTIFICATION_SETTING,
        icon: <FaBuilding />,
        subMenus: [],
      },
      {
        name: "Company Setting",
        key: AuthorizationList.view_company_setting,
        path: AppRoutePath.COMPANY_SETTING,
        icon: <BsFillGearFill />,
        subMenus: [],
      },
    ],
  },
};

export const SIDEBAR_FOOTER_MENU = [
  // {
  //   name: "",
  //   path: AppRoutePath.DASHBOARD,
  //   icon: <FaBell />,
  // },
  // {
  //   name: "",
  //   path: AppRoutePath.TASK_DAILY_TASK,
  //   icon: <FaUserCircle />,
  // },
  {
    name: "User",
    path: AppRoutePath.LOGIN,
    icon: <FaSignOutAlt />,
  },
];
